import Vue from "vue";
import App from "./app.vue";
import { createStore } from './store';
import { createRouter } from "./router";
import { i18n } from "@/plugins/i18n";

export function createApp() {
  const store = createStore();
  const router = createRouter();

  const app = new Vue({
    store,
    router,
    i18n,
    render: (h) => h(App),
  });
  return { app, store, router };
}
